import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { PacienteDTO } from '../../../dtos/paciente-dto';
import { Util } from '../../../util/util';
import { CustomDateValidator } from '../../../validators/custom-date-validator';
import { DependenteService } from '../dependente.service';

@Component({
  selector: 'app-dependente-list',
  templateUrl: './dependente-list.component.html',
  styleUrls: ['./dependente-list.component.css']
})
export class DependenteListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['dependente', 'dataNascimento', 'responsavel', 'details'];

  formularioDeConsultaDeDependente: FormGroup;

  filtroDependente: PacienteDTO;

  constructor(private dependenteService: DependenteService, router: Router, dialog: MatDialog,
    private formBuilder: FormBuilder) {

    super(router, dialog);

    this.filtroDependente = history.state.filtroDependente;

    this.formularioDeConsultaDeDependente = this.formBuilder.group({
      nome: ['', [Validators.minLength(3)]],
      dataNascimento: [''],
      responsavel: ['', [Validators.minLength(3)]],
    }, {
      validator: CustomDateValidator('dataNascimento')
    });
  }

  ngOnInit() {

    if (this.filtroDependente && (this.filtroDependente.nome || this.filtroDependente.dataNascimento || this.filtroDependente.responsavel)) {

      this.formularioDeConsultaDeDependente.setValue(this.filtroDependente);

      this.reloadData(this.filtroDependente);
    }

    super.ngOnInit();
  }

  reloadData(dependenteDTO: PacienteDTO) {

    if (!dependenteDTO.nome && !dependenteDTO.dataNascimento && !dependenteDTO.responsavel) {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Selecione pelo menos um campo de filtro!'
        }
      });

    } else {

      this.dependenteService.procurarDependentePorFiltro(dependenteDTO)
        .subscribe(data => {
          // console.log(data)
          this.data = data;
          this.configurarDataSource();
        }, error => {
          console.log(error);
        });

    }
  }

  onSubmit() {
    this.filtroDependente = this.formularioDeConsultaDeDependente.value;

    this.reloadData(this.filtroDependente);
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.dependenteService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData(this.filtroDependente);
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterDependente']);
  }

  details(id: number) {

    const dependenteDTO: PacienteDTO = this.formularioDeConsultaDeDependente.value;

    this.router.navigate(['manterDependente'], {
      state: {
        id: id,
        isUpdate: 'N',
        filtroDependente: dependenteDTO,
      }
    });
  }

  update(id: number) {

    const dependenteDTO: PacienteDTO = this.formularioDeConsultaDeDependente.value;

    this.router.navigate(['manterDependente'], {
      state: {
        id: id,
        isUpdate: 'S',
        filtroDependente: dependenteDTO,
      }
    });
  }

  transferirDependenteParaTitular(id: number): void {

    const dependenteDTO: PacienteDTO = this.formularioDeConsultaDeDependente.value;

    this.router.navigate(['transferirDependenteParaTitular'], {
      state: {
        id: id,
        filtroDependente: dependenteDTO,
      }
    });

  }

  pattern = Util.pattern;

}
